import React, { useState } from 'react';
import {Link, useNavigate} from 'react-router-dom';
import apiClient from '../../shared/services/apiService';
import API_CONFIG from '../../shared/config/api';
import waveImage from '../../assets/images/wave.png';
import orangeMoneyImage from '../../assets/images/orange_money.png';
import './PriceBlog.css';

const priceCard = [
    {
        title: 'Mensuel', 
        price: '3,000', 
        currency: 'FCFA', 
        period: '/mois', 
        package: '1',
        features: [
            'Publiez et recevez jusqu\'à 120 annonces par mois',
            'Accès aux appels d\'offres par Email uniquement',
            '1 utilisateur',
            'Conserver les annonces en ligne pendant 30 jours'
        ]
    },
    {
        title: 'Essential', 
        price: '25,000', 
        currency: 'FCFA', 
        period: '/année', 
        package: '2',
        popular: true,
        features: [
            'Publiez et recevez jusqu\'à 1200 annonces par année',
            'Accès aux appels d\'offres par Email uniquement',
            '1 utilisateur',
            'Idéal pour les entrepreneurs individuels',
            'Conserver les annonces en ligne pendant 365 jours'
        ]
    },
    {
        title: 'Standard', 
        price: '30,000', 
        currency: 'FCFA', 
        period: '/année', 
        package: '3',
        features: [
            'Publiez et recevez jusqu\'à 1500 annonces par année',
            'Appels d\'offres par Email + SMS',
            'Alertes quotidiennes rapides',
            'Jusqu\'à 2 utilisateurs',
            'Formule la plus équilibrée',
            'Conserver les annonces en ligne pendant 365 jours'
        ]
    },
    {
        title: 'Premium', 
        price: '100,000', 
        currency: 'FCFA', 
        period: '/année', 
        package: '4',
        features: [
            'Publiez et recevez jusqu\'à 2500 annonces par année',
            'Appels d\'offres par Email + SMS + WhatsApp',
            'Support prioritaire (réponse rapide)',
            'Utilisateurs illimités',
            'Pour les PME & grandes structures',
            'Conserver les annonces en ligne pendant 365 jours'
        ]
    }
];

const PriceBlog = () => {
    const navigate = useNavigate();
    const [showPaymentForm, setShowPaymentForm] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [selectedPayment, setSelectedPayment] = useState('orange');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [otpCode, setOtpCode] = useState('');

    const handlePlanSelection = (planType, price) => {
        // Vérifier si l'utilisateur est connecté - vérifier les deux systèmes d'auth
        const authToken = localStorage.getItem('auth_token');
        const userDetails = localStorage.getItem('userDetails');
        
        // Vérifier si l'utilisateur est connecté avec l'un des deux systèmes
        let isAuthenticated = false;
        
        if (authToken) {
            isAuthenticated = true;
        } else if (userDetails) {
            try {
                const parsed = JSON.parse(userDetails);
                // Vérifier si le token n'a pas expiré
                if (parsed.expireDate) {
                    const expireDate = new Date(parsed.expireDate);
                    const now = new Date();
                    isAuthenticated = now <= expireDate;
                } else {
                    isAuthenticated = !!parsed.token;
                }
            } catch (error) {
                isAuthenticated = false;
            }
        }
        
        if (!isAuthenticated) {
            // Stocker le plan sélectionné et rediriger vers login
            localStorage.setItem('selectedPlan', JSON.stringify({ planType, price }));
            navigate('/admin/login');
            return;
        }

        // Si connecté, afficher le formulaire de paiement
        setSelectedPlan({ title: planType, price: price });
        setShowPaymentForm(true);
    };

    const handlePayment = async () => {
        // Validation spécifique selon le mode de paiement
        if (selectedPayment === 'orange' && (!phoneNumber || !otpCode)) {
            alert('Veuillez remplir le numéro de téléphone et le code OTP pour Orange Money');
            return;
        }

        try {
            if (selectedPayment === 'wave') {
                // Intégration Wave
                const waveData = {
                    amount: parseInt(selectedPlan.price.replace(',', '')),
                    reference: `SENOFFRE_${Date.now()}`,
                    description: `Abonnement ${selectedPlan.title} - SenOffre`
                };

                console.log('Envoi des données Wave:', waveData);
                
                const response = await apiClient.post(API_CONFIG.ENDPOINTS.PAYMENTS.WAVE_INITIATE, waveData);
                
                if (response.data.success && response.data.data.wave_launch_url) {
                    // Rediriger vers l'URL de paiement Wave
                    window.location.href = response.data.data.wave_launch_url;
                } else {
                    alert('Erreur lors de l\'initialisation du paiement Wave');
                }
            } else if (selectedPayment === 'orange') {
                // Intégration Orange Money
                const orangeData = {
                    amount: parseInt(selectedPlan.price.replace(',', '')),
                    phoneNumber: phoneNumber,
                    otpCode: otpCode,
                    reference: `SENOFFRE_OM_${Date.now()}`,
                    description: `Abonnement ${selectedPlan.title} - SenOffre`
                };

                console.log('Envoi des données Orange Money:', orangeData);
                
                // Ici vous pouvez ajouter l'endpoint Orange Money si disponible
                // const response = await apiClient.post(API_CONFIG.ENDPOINTS.PAYMENTS.ORANGE_INITIATE, orangeData);
                
                alert('Intégration Orange Money en cours de développement');
            }
        } catch (error) {
            console.error('Erreur de paiement:', error);
            alert(`Erreur lors du paiement: ${error.response?.data?.message || error.message}`);
        }
    };

    const handleBackToPlans = () => {
        setShowPaymentForm(false);
        setSelectedPlan(null);
        setPhoneNumber('');
        setOtpCode('');
    };

    return (
        <div className="row justify-content-center">
            {!showPaymentForm ? (
                // Affichage des cartes de plans
                <div className="col-12">
                    <div className="row g-4">
                        {priceCard.map((item, index) => (
                            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12" key={index}>
                                <div 
                                    className="pricing-card h-100"
                                    style={{
                                        background: item.popular 
                                            ? 'linear-gradient(145deg, #10B981 0%, #059669 100%)'
                                            : 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)',
                                        border: item.popular ? 'none' : '2px solid #e2e8f0',
                                        borderRadius: '20px',
                                        padding: '32px 24px',
                                        position: 'relative',
                                        boxShadow: item.popular 
                                            ? '0 20px 40px rgba(16, 185, 129, 0.3)'
                                            : '0 8px 25px rgba(0, 0, 0, 0.08)',
                                        transform: item.popular ? 'scale(1.05)' : 'scale(1)',
                                        transition: 'all 0.3s ease',
                                        cursor: 'pointer'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!item.popular) {
                                            e.currentTarget.style.transform = 'scale(1.02)';
                                            e.currentTarget.style.boxShadow = '0 15px 35px rgba(0, 0, 0, 0.15)';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!item.popular) {
                                            e.currentTarget.style.transform = 'scale(1)';
                                            e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.08)';
                                        }
                                    }}
                                >
                                    {/* Badge populaire */}
                                    {item.popular && (
                                        <div style={{
                                            position: 'absolute',
                                            top: '-12px',
                                            left: '50%',
                                            transform: 'translateX(-50%)',
                                            background: '#FFD700',
                                            color: '#1F2937',
                                            padding: '6px 20px',
                                            borderRadius: '20px',
                                            fontSize: '12px',
                                            fontWeight: '700',
                                            textTransform: 'uppercase',
                                            boxShadow: '0 4px 12px rgba(255, 215, 0, 0.4)'
                                        }}>
                                            ⭐ Plus Populaire
                                        </div>
                                    )}

                                    {/* Header */}
                                    <div className="text-center mb-4">
                                        <h3 style={{
                                            color: item.popular ? 'white' : '#1F2937',
                                            fontWeight: '700',
                                            fontSize: '1.5rem',
                                            marginBottom: '8px'
                                        }}>
                                            {item.title}
                                        </h3>
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'baseline',
                                            justifyContent: 'center',
                                            gap: '4px'
                                        }}>
                                            <span style={{
                                                fontSize: '2.5rem',
                                                fontWeight: '800',
                                                color: item.popular ? 'white' : '#10B981'
                                            }}>
                                                {item.price.replace(',', ' ')}
                                            </span>
                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'flex-start'
                                            }}>
                                                <span style={{
                                                    fontSize: '1rem',
                                                    color: item.popular ? 'rgba(255,255,255,0.9)' : '#6B7280',
                                                    fontWeight: '600'
                                                }}>
                                                    {item.currency}
                                                </span>
                                                <span style={{
                                                    fontSize: '0.9rem',
                                                    color: item.popular ? 'rgba(255,255,255,0.7)' : '#9CA3AF'
                                                }}>
                                                    {item.period}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Features */}
                                    <div className="mb-4">
                                        <ul style={{
                                            listStyle: 'none',
                                            padding: 0,
                                            margin: 0
                                        }}>
                                            {item.features.map((feature, featureIndex) => (
                                                <li key={featureIndex} style={{
                                                    display: 'flex',
                                                    alignItems: 'flex-start',
                                                    marginBottom: '12px',
                                                    fontSize: '14px',
                                                    lineHeight: '1.5'
                                                }}>
                                                    <span style={{
                                                        color: item.popular ? '#FFD700' : '#10B981',
                                                        marginRight: '12px',
                                                        fontSize: '16px',
                                                        flexShrink: 0,
                                                        marginTop: '2px'
                                                    }}>
                                                        ✓
                                                    </span>
                                                    <span style={{
                                                        color: item.popular ? 'rgba(255,255,255,0.9)' : '#4B5563'
                                                    }}>
                                                        {feature}
                                                    </span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    {/* Button */}
                                    <button 
                                        onClick={() => handlePlanSelection(item.title, item.price.replace(',', ''))}
                                        style={{
                                            width: '100%',
                                            padding: '14px 24px',
                                            borderRadius: '12px',
                                            border: 'none',
                                            fontSize: '16px',
                                            fontWeight: '600',
                                            cursor: 'pointer',
                                            transition: 'all 0.3s ease',
                                            background: item.popular 
                                                ? 'white'
                                                : 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
                                            color: item.popular ? '#10B981' : 'white',
                                            boxShadow: item.popular 
                                                ? '0 4px 12px rgba(255, 255, 255, 0.3)'
                                                : '0 4px 12px rgba(16, 185, 129, 0.3)'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.transform = 'translateY(-2px)';
                                            e.target.style.boxShadow = item.popular 
                                                ? '0 8px 20px rgba(255, 255, 255, 0.4)'
                                                : '0 8px 20px rgba(16, 185, 129, 0.5)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.transform = 'translateY(0)';
                                            e.target.style.boxShadow = item.popular 
                                                ? '0 4px 12px rgba(255, 255, 255, 0.3)'
                                                : '0 4px 12px rgba(16, 185, 129, 0.3)';
                                        }}
                                    >
                                        {item.popular ? '🚀 Choisir Essential' : 'Démarrer'}
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                // Affichage du formulaire de paiement
                <div className="col-lg-8">
                    <div className="card border-0 shadow-lg" style={{
                        borderRadius: '20px',
                        overflow: 'hidden',
                        background: 'linear-gradient(145deg, #ffffff 0%, #f8fffe 100%)'
                    }}>
                        <div className="card-header text-center py-5" style={{
                            background: 'linear-gradient(135deg, #10B981 0%, #059669 50%, #047857 100%)',
                            color: 'white',
                            position: 'relative'
                        }}>
                            <div style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.1"%3E%3Ccircle cx="30" cy="30" r="2"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
                                opacity: 0.3
                            }}></div>
                            <div style={{ position: 'relative', zIndex: 1 }}>
                                <div className="mb-3">
                                    <span style={{
                                        background: 'rgba(255,255,255,0.2)',
                                        padding: '8px 16px',
                                        borderRadius: '25px',
                                        fontSize: '14px',
                                        fontWeight: '500'
                                    }}>
                                        💳 Paiement Sécurisé
                                    </span>
                                </div>
                                <h2 className="mb-2" style={{ fontWeight: '700', fontSize: '2rem' }}>
                                    Finaliser votre abonnement
                                </h2>
                                <div style={{
                                    background: 'rgba(255,255,255,0.15)',
                                    padding: '12px 24px',
                                    borderRadius: '15px',
                                    display: 'inline-block',
                                    backdropFilter: 'blur(10px)'
                                }}>
                                    <span style={{ fontSize: '16px', opacity: 0.9 }}>Plan sélectionné: </span>
                                    <strong style={{ fontSize: '18px' }}>{selectedPlan?.title}</strong>
                                    <span style={{ 
                                        marginLeft: '12px',
                                        fontSize: '24px',
                                        fontWeight: '800',
                                        color: '#FFD700'
                                    }}>
                                        {selectedPlan?.price} FCFA
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="card-body p-5">
                            {/* Méthodes de paiement */}
                            <div className="mb-4">
                                <h4 className="text-center mb-4" style={{ 
                                    color: '#1F2937', 
                                    fontWeight: '600',
                                    fontSize: '1.3rem'
                                }}>
                                    Choisissez votre méthode de paiement
                                </h4>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div 
                                            className="payment-method-card"
                                            onClick={() => setSelectedPayment('orange')}
                                            style={{
                                                cursor: 'pointer',
                                                border: selectedPayment === 'orange' ? '3px solid #F59E0B' : '2px solid #E5E7EB',
                                                borderRadius: '16px',
                                                padding: '24px',
                                                background: selectedPayment === 'orange' 
                                                    ? 'linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%)' 
                                                    : 'white',
                                                boxShadow: selectedPayment === 'orange' 
                                                    ? '0 10px 25px rgba(245, 158, 11, 0.3)' 
                                                    : '0 4px 6px rgba(0, 0, 0, 0.05)',
                                                transform: selectedPayment === 'orange' ? 'translateY(-2px)' : 'none',
                                                transition: 'all 0.3s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                if (selectedPayment !== 'orange') {
                                                    e.target.style.transform = 'translateY(-2px)';
                                                    e.target.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.1)';
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                if (selectedPayment !== 'orange') {
                                                    e.target.style.transform = 'none';
                                                    e.target.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.05)';
                                                }
                                            }}
                                        >
                                            <div className="text-center">
                                                <div className="mb-3" style={{
                                                    height: '60px', 
                                                    display: 'flex', 
                                                    alignItems: 'center', 
                                                    justifyContent: 'center'
                                                }}>
                                                    <img src={orangeMoneyImage} alt="Orange Money" style={{height: '50px'}} />
                                                </div>
                                                <h5 style={{ 
                                                    fontWeight: '600', 
                                                    color: selectedPayment === 'orange' ? '#92400E' : '#374151',
                                                    marginBottom: '8px'
                                                }}>
                                                    Orange Money
                                                </h5>
                                                <p style={{ 
                                                    fontSize: '14px', 
                                                    color: selectedPayment === 'orange' ? '#A16207' : '#6B7280',
                                                    margin: 0
                                                }}>
                                                    Paiement mobile sécurisé
                                                </p>
                                                {selectedPayment === 'orange' && (
                                                    <div style={{
                                                        marginTop: '12px',
                                                        background: '#F59E0B',
                                                        color: 'white',
                                                        padding: '6px 12px',
                                                        borderRadius: '20px',
                                                        fontSize: '12px',
                                                        fontWeight: '600'
                                                    }}>
                                                        ✓ Sélectionné
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div 
                                            className="payment-method-card"
                                            onClick={() => setSelectedPayment('wave')}
                                            style={{
                                                cursor: 'pointer',
                                                border: selectedPayment === 'wave' ? '3px solid #3B82F6' : '2px solid #E5E7EB',
                                                borderRadius: '16px',
                                                padding: '24px',
                                                background: selectedPayment === 'wave' 
                                                    ? 'linear-gradient(135deg, #DBEAFE 0%, #BFDBFE 100%)' 
                                                    : 'white',
                                                boxShadow: selectedPayment === 'wave' 
                                                    ? '0 10px 25px rgba(59, 130, 246, 0.3)' 
                                                    : '0 4px 6px rgba(0, 0, 0, 0.05)',
                                                transform: selectedPayment === 'wave' ? 'translateY(-2px)' : 'none',
                                                transition: 'all 0.3s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                if (selectedPayment !== 'wave') {
                                                    e.target.style.transform = 'translateY(-2px)';
                                                    e.target.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.1)';
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                if (selectedPayment !== 'wave') {
                                                    e.target.style.transform = 'none';
                                                    e.target.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.05)';
                                                }
                                            }}
                                        >
                                            <div className="text-center">
                                                <div className="mb-3" style={{
                                                    height: '60px', 
                                                    display: 'flex', 
                                                    alignItems: 'center', 
                                                    justifyContent: 'center'
                                                }}>
                                                    <img src={waveImage} alt="Wave" style={{height: '50px'}} />
                                                </div>
                                                <h5 style={{ 
                                                    fontWeight: '600', 
                                                    color: selectedPayment === 'wave' ? '#1E40AF' : '#374151',
                                                    marginBottom: '8px'
                                                }}>
                                                    Wave
                                                </h5>
                                                <p style={{ 
                                                    fontSize: '14px', 
                                                    color: selectedPayment === 'wave' ? '#1D4ED8' : '#6B7280',
                                                    margin: 0
                                                }}>
                                                    Paiement instantané
                                                </p>
                                                {selectedPayment === 'wave' && (
                                                    <div style={{
                                                        marginTop: '12px',
                                                        background: '#3B82F6',
                                                        color: 'white',
                                                        padding: '6px 12px',
                                                        borderRadius: '20px',
                                                        fontSize: '12px',
                                                        fontWeight: '600'
                                                    }}>
                                                        ✓ Sélectionné
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Formulaire de paiement */}
                            <div className="row">
                                <div className="col-md-8 mx-auto">
                                    {selectedPayment === 'orange' && (
                                        <div style={{
                                            background: 'linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%)',
                                            padding: '24px',
                                            borderRadius: '16px',
                                            border: '1px solid #F59E0B',
                                            marginBottom: '24px'
                                        }}>
                                            <div className="mb-4">
                                                <label style={{ 
                                                    fontWeight: '600', 
                                                    color: '#92400E',
                                                    marginBottom: '8px',
                                                    display: 'block'
                                                }}>
                                                    📱 Numéro de téléphone Orange
                                                </label>
                                                <input 
                                                    type="tel" 
                                                    style={{
                                                        width: '100%',
                                                        padding: '12px 16px',
                                                        borderRadius: '12px',
                                                        border: '2px solid #F59E0B',
                                                        fontSize: '16px',
                                                        background: 'white',
                                                        outline: 'none'
                                                    }}
                                                    placeholder="77 123 45 67"
                                                    value={phoneNumber}
                                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label style={{ 
                                                    fontWeight: '600', 
                                                    color: '#92400E',
                                                    marginBottom: '8px',
                                                    display: 'block'
                                                }}>
                                                    🔐 Code OTP Orange Money
                                                </label>
                                                <input 
                                                    type="text" 
                                                    style={{
                                                        width: '100%',
                                                        padding: '12px 16px',
                                                        borderRadius: '12px',
                                                        border: '2px solid #F59E0B',
                                                        fontSize: '16px',
                                                        background: 'white',
                                                        outline: 'none'
                                                    }}
                                                    placeholder="Entrez le code reçu"
                                                    value={otpCode}
                                                    onChange={(e) => setOtpCode(e.target.value)}
                                                />
                                                <div style={{
                                                    marginTop: '12px',
                                                    padding: '12px',
                                                    background: 'rgba(245, 158, 11, 0.1)',
                                                    borderRadius: '8px',
                                                    fontSize: '14px',
                                                    color: '#92400E'
                                                }}>
                                                    💡 <strong>Composez #144#391#</strong> sur votre téléphone pour recevoir le code OTP
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {selectedPayment === 'wave' && (
                                        <div style={{
                                            background: 'linear-gradient(135deg, #DBEAFE 0%, #BFDBFE 100%)',
                                            padding: '24px',
                                            borderRadius: '16px',
                                            border: '1px solid #3B82F6',
                                            marginBottom: '24px',
                                            textAlign: 'center'
                                        }}>
                                            <div style={{
                                                fontSize: '48px',
                                                marginBottom: '16px'
                                            }}>
                                                🚀
                                            </div>
                                            <h5 style={{ 
                                                color: '#1E40AF', 
                                                fontWeight: '600',
                                                marginBottom: '12px'
                                            }}>
                                                Paiement instantané avec Wave
                                            </h5>
                                            <p style={{ 
                                                color: '#1D4ED8', 
                                                margin: 0,
                                                fontSize: '15px'
                                            }}>
                                                Vous serez redirigé vers la page de paiement Wave sécurisée pour finaliser votre transaction en quelques secondes.
                                            </p>
                                        </div>
                                    )}

                                    <div className="d-grid gap-3">
                                        <button 
                                            onClick={handlePayment}
                                            disabled={selectedPayment === 'orange' && (!phoneNumber || !otpCode)}
                                            style={{
                                                background: selectedPayment === 'wave' 
                                                    ? 'linear-gradient(135deg, #3B82F6 0%, #1D4ED8 100%)'
                                                    : 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
                                                border: 'none',
                                                color: 'white',
                                                padding: '16px 32px',
                                                borderRadius: '12px',
                                                fontSize: '18px',
                                                fontWeight: '600',
                                                cursor: selectedPayment === 'orange' && (!phoneNumber || !otpCode) ? 'not-allowed' : 'pointer',
                                                opacity: selectedPayment === 'orange' && (!phoneNumber || !otpCode) ? 0.6 : 1,
                                                boxShadow: '0 4px 15px rgba(16, 185, 129, 0.4)',
                                                transition: 'all 0.3s ease',
                                                transform: 'translateY(0)'
                                            }}
                                            onMouseEnter={(e) => {
                                                if (!(selectedPayment === 'orange' && (!phoneNumber || !otpCode))) {
                                                    e.target.style.transform = 'translateY(-2px)';
                                                    e.target.style.boxShadow = '0 8px 25px rgba(16, 185, 129, 0.6)';
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                if (!(selectedPayment === 'orange' && (!phoneNumber || !otpCode))) {
                                                    e.target.style.transform = 'translateY(0)';
                                                    e.target.style.boxShadow = '0 4px 15px rgba(16, 185, 129, 0.4)';
                                                }
                                            }}
                                        >
                                            {selectedPayment === 'wave' ? (
                                                <>🌊 Payer avec Wave - {selectedPlan?.price} FCFA</>
                                            ) : (
                                                <>💰 Payer {selectedPlan?.price} FCFA</>
                                            )}
                                        </button>
                                        <button 
                                            onClick={handleBackToPlans}
                                            style={{
                                                background: 'transparent',
                                                border: '2px solid #E5E7EB',
                                                color: '#6B7280',
                                                padding: '12px 24px',
                                                borderRadius: '12px',
                                                fontSize: '16px',
                                                fontWeight: '500',
                                                cursor: 'pointer',
                                                transition: 'all 0.3s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.borderColor = '#10B981';
                                                e.target.style.color = '#10B981';
                                                e.target.style.background = 'rgba(16, 185, 129, 0.05)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.borderColor = '#E5E7EB';
                                                e.target.style.color = '#6B7280';
                                                e.target.style.background = 'transparent';
                                            }}
                                        >
                                            ← Retour aux plans
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PriceBlog;